<template>
<!--  1px is a trick so the element gets a height which can be inherited. -->
  <q-page style="height: 1px">
    <product-category-filter />
    <br><br>
    <div class="column" style="height: 100%">
      <!-- Container status message -->
      <div class="text-primary col-auto text-center">
        <div v-if="!$apollo.queries.activeGroupOrder.loading">
          <q-banner v-if="activeGroupOrder">
            <span class="medium-text">{{activeGroupOrder.name}} is open
              <span v-if="orderClosingSoon">- closes <u>{{fromNow(activeGroupOrder.closeDate)}}</u>
              <q-tooltip>Closes {{formatDateTime(activeGroupOrder.closeDate)}}</q-tooltip></span>
              <span v-else>.  Closing soon!</span>
            </span>
          </q-banner>
          <q-banner  v-else>
            <span class="medium-text">There is currently no container open for orders.</span>
          </q-banner>
        </div>
      </div>
      <!-- End Container status message -->
      <!-- Mobile Version -->
      <div v-if="$q.screen.lt.md">
        <div class="row flex-center">
          <span style="cursor: pointer; display: none;">
            {{(activeCart||{}).name}}
            <edit-cart-menu store-type="container"/>
          </span>

          <span class="q-mr-md q-ml-md">Sort By:</span>
          <div class="col" v-if="displayType==='grid'">
            <q-select
              v-model="orderBy"
              :options="orderByOptions"
              class="q-mr-xl"
              style="max-width:120px"
              dense           
            />
          </div>
          <div class="q-mr-md q-ml-md text-h6">
            {{resultCount}} Items
          </div>
        </div>
        <div style="min-height:15px"></div>
      </div>
      <!-- END Mobile Version -->

      <!-- Desktop Version -->
      <div class="row flex-center" style="height: 70px" v-else>
        <div class="col-1"></div>
        <div class="col-3 text-h6">
          <span style="cursor: pointer; display: none;">
            {{(activeCart||{}).name}}
            <edit-cart-menu store-type="container"/>
          </span>
        </div>
          <div v-if="displayType==='grid'">
            <div class="q-mr-md" style="display: inline-block;">Sort By:</div>  
            <q-select
              v-model="orderBy"
              :options="orderByOptions"
              class="q-mr-lg"
              style="min-width:120px; display: inline-block;"
              dense           
            />
          </div>
        <div class="col-s-4 col-xl-auto text-right text-h5">
          {{resultCount}} Items
          <q-btn flat dense icon="view_module" class="text-h5" :color="displayType==='grid'?'primary':''"
                 @click="setDisplayType('grid');trk_display_type('grid')"/>
          <q-btn flat dense icon="view_list" class="text-h5" :color="displayType==='table'?'primary':''"
                 @click="setDisplayType('table');trk_display_type('table')"/>
        </div>
        <div class="col-1"></div>
      </div>
      <!-- END Desktop Version -->

      <q-scroll-area class="col">
        <div class="justify-around row" v-if="resultCount">
          <div class="col-10" >
            <router-view :products="products" storeType="container" @loadMore="fetchMore" :productCount="resultCount" ></router-view>
          </div>
        </div>
      </q-scroll-area>
    </div>
    <product-dialog storeType="container"></product-dialog>

    <!-- <q-page-sticky position="bottom-right" :offset="[18, 18]"> -->
      <!-- <q-btn to="/container/cart" round icon="shopping_cart" color="primary" size="lg"> -->
        <!-- <q-badge v-if="totalHolds" color="black" floating transparent style="font-size: 0.8em; left: -8px; right: auto; top: -10px; padding: 5px;">{{totalHolds}}</q-badge> -->
        <!-- <q-tooltip content-style="font-size: 1em; width: 12em;"> -->
          <!-- <p class="text-h6 q-mb-xs"><b>Cart Summary</b></p> -->
          <!-- <b>Number of holds:</b> {{totalHolds}}<br/> -->
          <!-- <b>Number of sets:</b> {{totalSets}}<br/> -->
          <!-- <b>Total Cost:</b> {{ formatCurrency(totalCost) }} -->
        <!-- </q-tooltip> -->
      <!-- </q-btn> -->
    <!-- </q-page-sticky> -->

  </q-page>
</template>

<script>
import ProductDialog from '../../components/ProductDialog'
import ProductCategoryFilter from '../../components/ProductCategoryFilter'
import gql from 'graphql-tag'
import { mapGetters } from 'vuex'
import EditCartMenu from '../../components/EditCartMenu'
import { formatCurrency, formatDateTime } from '../../util/string'
import moment from 'moment'

export default {
  name: 'PageStockProduct',
  components: {
    EditCartMenu,
    ProductDialog,
    ProductCategoryFilter
  },
  apollo: {
    activeGroupOrder () {
      return {
        query: gql`
          query {
            activeGroupOrder {
              id
              name
              openDate
              closeDate
            }
          }
        `
      }
    },
    products () {
      return {
        query: gql`
          query products ($filter: ProductFilterInput, $limit: Int, $offset: Int, $orderBy: ProductsOrderByFieldInput, $descending: SortOrderInput) {
            products(filter: $filter, store: Container, limit: $limit, offset: $offset, orderBy: $orderBy, descending: $descending) {
              products {
                id,
                name,
                reference,
                attributes,
                images {
                  url
                  name
                },
                urlSlug,
                description,
                skus {
                  id,
                  showInContainer,
                  containerPrice,
                  options,
                  stock,
                  previousStock, 
                  stockLastUpdate,
                  createdAt,
                  updatedAt
                },
                createdAt,
                updatedAt
              }
              count
            }
          }
        `,
        skip: () => !this.currentAccount,
        variables () {
          return {
            filter: this.productFilterGql,
            limit: 20,
            offset: 0,
            orderBy: this.orderBy?.toLowerCase(),
            descending: 'Ascending'
          }
        },
        update (result) {
          this.trk_products_loaded(result.products.products.length,result.products.count)
          this.resultCount = result.products.count
          return result.products.products
        },
        fetchPolicy: 'network-only'
      }
    },
    activeCart () {
      return {
        query: gql`
          query activeCart ($id: ID!) {
            cart(id: $id) {
              id,
              name
              items {
                id,
                skuId,
                qty,
                sku {
                  id,
                  options,
                  containerPrice,
                  product {
                      id,
                      attributes
                  }
                }
              }
            }
          }
        `,
        variables () {
          return {
            id: this.activeContainerCartId
          }
        },
        update: data => data.cart,
        skip: () => !this.currentAccount,
        error (error) {
          if (error.message === `GraphQL error: Cart with id ${this.activeContainerCartId} does not exist.`) {
            return this.$store.dispatch('cart/createNewActiveCart', { input: { name: `Factory Cart ${moment().format('DD/MM/YY')}` }, storeType: 'container' })
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('filters', ['productFilterGql']),
    displayType () {
      return this.$route.path.split('/').slice(-1)[0]
    },
    currentAccount () {
      return this.$store.state.auth.currentAccount
    },
    activeContainerCartId () {
      return this.currentAccount?.activeContainerCartId
    },
    totalHolds () {
      return this.activeCart?.items?.reduce((p, c, i) => p + ((c.sku?.product?.attributes?.holds || 0) * Number(c.qty)), 0)
    },
    totalSets () {
      return this.activeCart?.items?.reduce((p, c, i) => p + Number(c.qty), 0)
    },
    totalCost () {
      return this.activeCart?.items?.reduce((p, c, i) => p + ((c.sku?.containerPrice || 0) * Number(c.qty)), 0)
    },
    orderClosingSoon () {
      return moment(this.activeGroupOrder.closeDate).isAfter(moment())
    }
  },
  methods: {
    trk_display_type(selection){      
      analytics.track("Product Display Type", {
        type: selection,
        storeType: this.$store.state.cart.currentStoreType,
      });    
    },
    trk_products_loaded(loadedQty,totalProducts){      
      analytics.track("Products Loaded", {
        loaded: loadedQty,
        total: totalProducts,
        secondsBetweenLoads: (Date.now() - this.loadedAt)/1000,
        storeType: this.$store.state.cart.currentStoreType,
      });
      //Reset date
      this.loadedAt = Date.now();    
    },    
    formatDateTime: formatDateTime,
    fromNow (t) {
      if (!t) return '-'
      return moment(t).fromNow()
    },
    async fetchMore (done) {
      try {
        await this.$apollo.queries.products.fetchMore({
          variables: {
            offset: this.products.length,
          },
          updateQuery: (previousQueryResult, { fetchMoreResult }) => {
            if (!previousQueryResult) {
              this.$apollo.queries.products.refetch()
              done()
              return null
            }
            if (!fetchMoreResult.products?.products?.length) {
              done(true)
              return previousQueryResult
            }
            done()
            return Object.assign({}, previousQueryResult, {
              products: {
                __typename: previousQueryResult.products.__typename,
                products: [...previousQueryResult.products.products, ...fetchMoreResult.products.products],
                count: previousQueryResult.products.count
              }
            })
          }
        })
      } catch (error) {
        done()
        this.$nextTick(() => {
          this.$apollo.queries.products.refetch()
        })
      }
    },
    formatCurrency: formatCurrency,
    setDisplayType (displayType) {
      this.$router.push(`/container/${displayType}`)
    }
  },
  data () {
    return {
      products: [],
      resultCount: 0,
      orderBy: 'Newest',
      orderByOptions: ['Brand', 'Range', 'Name', 'Price', 'Newest'],
      thumbStyle: {
        right: '2px',
        borderRadius: '5px',
        backgroundColor: '#c5161c',
        width: '7px',
        opacity: 0.75
      },
      loadedAt: Date.now()
    }
  }
}
</script>

<style scoped lang="stylus">
  @import '~quasar-variables'
  .q-banner{
    .medium-text {
      font-size 40px;
      @media (max-width $breakpoint-sm) {
        font-size 20px;
      }
    }
  }
</style>